/**
 * Session storage keys and values used throughout the application
 */
export const SESSION_STORAGE_KEYS = {
  USER_JUST_SIGNED_IN: 'user-just-signed-in',
} as const;

export const SESSION_STORAGE_VALUES = {
  USER_JUST_SIGNED_IN: '1',
} as const;
